export default "__VITE_ASSET__CPjZ5aGz__"